import { api } from './api';

export const adminDashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAdminDashboard: builder.query({
      query: () => '/admin/dashboard',
      providesTags: ['AdminDashboard'],
    }),
    updatePaidMemberTarget: builder.mutation({
      query: (target) => ({
        url: '/admin/dashboard/paid-member-target',
        method: 'PATCH',
        body: { target },
      }),
      invalidatesTags: ['AdminDashboard'],
    }),
  }),
});

export const {
  useGetAdminDashboardQuery,
  useUpdatePaidMemberTargetMutation,
} = adminDashboardApi;
